<div>
  <div *ngIf="!isSubscriptionSelected">
    <h1 style="font-weight: 600;">Abonnement</h1>

    <div class="add-abo-btn" [class.disabled]="loading" *ngIf="this.isUserAdminOfOrganisationOrPlattformAdmin()">

      <button matButton="elevated" color="primary" (click)="showTarifeSelectionDialog()">
        Neues Abonnement
      </button>
    </div>

    <mat-card style="box-shadow: none; padding: 0;" *ngIf="subscriptions">
      <div class="abo" *ngFor="let subscription of subscriptions.subscriptions">
        <app-abonnements [admin]="isUserAdminOfOrganisationOrPlattformAdmin()" [orgId]="activeOrg"
          [packageId]="subscription.id" [packageNumber]="subscription.name" [startDate]="subscription.startDate | date"
          [endDate]="subscription.endDate | date" [licensesUsed]="subscription.used"
          [licensesTotal]="subscription.capacity" [price]="subscription.products[0].price"
          [features]="subscription.products[0].product.features" [subscription]="subscription"
          (subscriptionChange)="selectedSubscription = $event"
          (isSubscriptionSelected)="handleAbonnementAction()"></app-abonnements>
      </div>
      <mat-paginator [length]="totalNumberOfElements" [pageIndex]="this.pageIndex" [pageSize]="this.pageSize"
        (page)="onPageChange($event)" [pageSizeOptions]="[5,10]"></mat-paginator>
    </mat-card>
  </div>
</div>
<div *ngIf="isSubscriptionSelected">
  <div class="backHeader">
    <button mat-button (click)="goBack()">
      <mat-icon>arrow_back</mat-icon>
      Zurück zu Abonnements Seite
    </button>
  </div>
  <h1 style="padding-left: 16px; font-weight: 600; margin-top: 16px;">Abonnement - {{ selectedSubscription.id }}</h1>
  <app-dialog-abo-verwaltung [subscription]="selectedSubscription"></app-dialog-abo-verwaltung>
</div>
<div *ngIf="loading" class="loading-overlay-spinner">
  <mat-spinner></mat-spinner>
</div>